'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DetailsLink = require('components/DetailsLink/DetailsLink');

var _DetailsLink2 = _interopRequireDefault(_DetailsLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatisticsTracksDetailsLink = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(StatisticsTracksDetailsLink, _PureComponent);

  function StatisticsTracksDetailsLink() {
    (0, _classCallCheck3.default)(this, StatisticsTracksDetailsLink);
    return (0, _possibleConstructorReturn3.default)(this, (StatisticsTracksDetailsLink.__proto__ || (0, _getPrototypeOf2.default)(StatisticsTracksDetailsLink)).apply(this, arguments));
  }

  (0, _createClass3.default)(StatisticsTracksDetailsLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          projectId = _props.projectId;
      var t = this.context.t;


      return _react2.default.createElement(_DetailsLink2.default, {
        className: className,
        to: '/statistics/project/' + projectId + '/details',
        title: t('Details by tracks')
      });
    }
  }]);
  return StatisticsTracksDetailsLink;
}(_react.PureComponent), _class.propTypes = {
  className: _propTypes2.default.string,
  projectId: _propTypes2.default.number
}, _class.contextTypes = {
  t: _propTypes2.default.func
}, _temp);
exports.default = StatisticsTracksDetailsLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsTracksDetailsLink/StatisticsTracksDetailsLink.js
// module id = 2128
// module chunks = 1